const visibleDateReducer = (state = new Date("2002-01-01"), action) => {
  switch(action.type) {
    case 'DATE_CHANGED':
      return action.payload;
    default:
      return state
    }
  }

export default visibleDateReducer;